import { Link } from 'react-router-dom';
import ComicCard from './ComicCard';
import { hotComics } from '@/mocks/comics';

export default function HotComics() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="inline-block px-4 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-3">
              热门推荐
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              大家都在看的<span className="text-primary-600">韩漫</span>
            </h2>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {hotComics.map(comic => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 px-6 py-2.5 bg-primary-500 text-white text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部漫画
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}